import { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";
import PricingSection from '../components/PricingSection';
import QuoteModal from '../components/QuoteModal';
import ExperienceSection from '../components/ExperienceSection';

export default function HomePage() {
  useEffect(() => {
    if (typeof window !== "undefined" && window.$) {
      const $ = window.$;

      // 1. Simple Counter Up
      if ($(".number1").length) {
        $.fn.$SimpleCounter = function (options) {
          var settings = $.extend({ start: 0, end: 100, easing: "swing", duration: 400, complete: "" }, options);
          var thisElement = $(this);
          $({ count: settings.start }).animate(
            { count: settings.end },
            {
              duration: settings.duration,
              easing: settings.easing,
              step: function () {
                var mathCount = Math.ceil(this.count);
                thisElement.text(mathCount);
              },
              complete: settings.complete,
            }
          );
        };
        $(".number1").$SimpleCounter({ end: 500, duration: 3000 });
        $(".number2").$SimpleCounter({ end: 350, duration: 3000 });
        $(".number3").$SimpleCounter({ end: 8, duration: 2000 });
        $(".number4").$SimpleCounter({ end: 15, duration: 2500 });
      }

      // 2. Search block
      $(".search-block").off("click").on("click", function () {
        $(".search-box").fadeToggle("slow").css({ top: "61px" });
        $(".search-block .fa").toggleClass("fa-times fa-search").addClass("fa-search");
      });

      // 3. GLightbox
      if ($(".btn_gallery").length && typeof GLightbox !== "undefined") {
        const galleryLightbox = GLightbox({ selector: ".btn_gallery" });
      }

      // 4. Hero Swiper
      if ($(".hero-slider").length && typeof Swiper !== "undefined") {
        const sliderItems = document.querySelectorAll(".slider-item");
        const container = document.querySelectorAll(".slide_img_container");
        const slice = 10;

        const swiper99 = new Swiper(".hero-slider", {
          direction: "horizontal",
          loop: true,
          autoplay: { delay: 5000, disableOnInteraction: false },
          speed: 2000,
          pagination: { el: ".swiper-pagination", type: "bullets", clickable: true },
          navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
          on: {
            slideChange: function () {
              sliderItems.forEach((item) => item.classList.remove("animate"));
              sliderItems.forEach((item) => setTimeout(() => $(item).addClass("animate"), 1000));
              splitImage("", slice, slice, container);
            },
          },
        });

        swiper99.on("slideChange", function () {
          updatePagination(this);
        });

        function updatePagination(swiper) {
          if (!swiper.slides || swiper.slides.length === 0) return;
          var currentSlide = swiper.slides[swiper.activeIndex];
          if (!currentSlide) return;
          var nextSlide = swiper.slides[(swiper.activeIndex + 1) % swiper.slides.length];
          var prevSlide = swiper.slides[(swiper.activeIndex - 1 + swiper.slides.length) % swiper.slides.length];

          var containerEl = currentSlide.querySelector(".slide_img_container");
          var currentImageSrc = containerEl ? containerEl.getAttribute("data-src") : "";
          var nextContainerEl = nextSlide.querySelector(".slide_img_container");
          var nextImageSrc = nextContainerEl ? nextContainerEl.getAttribute("data-src") : "";
          var prevContainerEl = prevSlide.querySelector(".slide_img_container");
          var prevImageSrc = prevContainerEl ? prevContainerEl.getAttribute("data-src") : "";

          var paginationBullets = document.querySelectorAll(".swiper-pagination-bullet");
          if (paginationBullets.length > swiper.activeIndex) {
            paginationBullets[swiper.activeIndex].style.backgroundImage = "url(" + currentImageSrc + ")";
          }
          var prevIndex = (swiper.activeIndex - 1 + swiper.slides.length) % swiper.slides.length;
          if (paginationBullets.length > prevIndex) {
            paginationBullets[prevIndex].style.backgroundImage = "url(" + prevImageSrc + ")";
          }
          var nextIndex = (swiper.activeIndex + 1) % swiper.slides.length;
          if (paginationBullets.length > nextIndex) {
            paginationBullets[nextIndex].style.backgroundImage = "url(" + nextImageSrc + ")";
          }
        }

        function splitImage(imageUrl, numCols, numRows, container) {
          container.forEach((item) => {
            item.innerHTML = "";
            item.classList.remove("bg-animate-duration", "bg-animate");
            for (let y = 0; y < numRows; y++) {
              for (let x = 0; x < numCols; x++) {
                const div = document.createElement("div");
                div.className = "animation-part";
                div.style.backgroundImage = `url('${imageUrl}')`;
                const posX = x * 100;
                const posY = y * 100;
                div.style.backgroundPosition = `-${posX}% -${posY}%`;
                item.appendChild(div);
              }
            }
            setTimeout(() => {
              item.classList.add("bg-animate-duration", "bg-animate");
            }, 2000);
          });
        }

        updatePagination(swiper99);
        splitImage("", slice, slice, container);
        $(".swiper-pagination-bullet").addClass("swiper-pagination-style");
      }

      // 5. Isotope Gallery
      if ($("#portfolio-filter7").length && typeof $.fn.isotope !== "undefined") {
        var $container = $("#portfolio-filter7").isotope({
          itemSelector: ".item",
          isFitWidth: true,
        });
        $(window).resize(function () {
          $container.isotope({ columnWidth: ".col-sm-3" });
        });
        $container.isotope({ filter: "*" });
        $("#filters").off("click", "button").on("click", "button", function () {
          var filterValue = $(this).attr("data-filter");
          $container.isotope({ filter: filterValue });
          $("#filters button").removeClass("active");
          $(this).addClass("active");
        });
      }

      // 6. AOS animations
      if (typeof AOS !== "undefined") {
        AOS.init({ easing: "ease-in-out-sine" });
      }

      // 7. Mobile menu toggle handlers
      const $menuArea = $(".mobile-menu-area");
      const $hamburger = $(".mobile-menu-toggle-new-line");
      const $menuClose = $(".mobile-menu-area .mobile-menu-close");
      const $menuOverlay = $(".mobile-menu-area .mobile-menu-overlay");

      $hamburger.off("click").on("click", function () {
        $menuArea.addClass("menu-open");
        $("body").css("overflow", "hidden");
        $(".line").addClass("change");
      });

      function closeMenu() {
        $menuArea.removeClass("menu-open");
        $("body").css("overflow", "");
        $(".line").removeClass("change");
      }

      $menuClose.off("click").on("click", closeMenu);
      $menuOverlay.off("click").on("click", closeMenu);

      const wrapper = document.querySelector(".mobile-menu-area .mobile-menu-wrapper");
      if (wrapper) {
        wrapper.addEventListener("click", function (e) {
          var link = e.target.closest(".menu-item-has-children > a");
          if (link) {
            e.preventDefault();
            e.stopPropagation();
            var submenu = link.nextElementSibling;
            if (submenu) {
              submenu.classList.toggle("open");
              link.closest(".menu-item-has-children").classList.toggle("submenu-open");
            }
            return;
          }
          var navLink = e.target.closest(".mobile-menu-nav > ul > li:not(.menu-item-has-children) > a, .mobile-menu-nav .sm-submenu a");
          if (navLink) {
            closeMenu();
          }
        });
      }

      // 8. Global Quote Modal toggle handlers
      $(".get-quote-btn").off("click").on("click", function (e) {
        e.preventDefault();
        $("#quoteModal").addClass("show");
        $("body").css("overflow", "hidden");
      });
      $(".quote-modal-close, .quote-done-btn").off("click").on("click", function () {
        $("#quoteModal").removeClass("show");
        $("body").css("overflow", "");
        $("#quoteSuccess").removeClass("show");
        $("#quoteForm").show();
      });
      $("#quoteForm").off("submit").on("submit", function (e) {
        e.preventDefault();
        // simulate success
        $(this).hide();
        $("#quoteSuccess").addClass("show");
      });

      // 9. FAQ accordion
      $(".faq-block-2 .accordion-list > li > .answer").hide();
      // keep first active open
      $(".faq-block-2 .accordion-list > li.active > .answer").show();
      $(".faq-block-2 .accordion-list > li").off("click").on("click", function () {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active").find(".answer").slideUp();
        } else {
          $(".faq-block-2 .accordion-list > li.active .answer").slideUp();
          $(".faq-block-2 .accordion-list > li.active").removeClass("active");
          $(this).addClass("active").find(".answer").slideDown();
        }
        return false;
      });
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Tech Zone FZC | IT Products & Services Dubai, UAE</title>
        <meta name="description" content="Tech Zone FZC is a certified IT company in Dubai & Middle East & African Regionoffering Web & App Development, Cloud & DevOps, VPS Hosting, Cybersecurity, AI & Data solutions with 15+ years of experience." />
        <meta name="keywords" content="IT services Dubai, web development Middle East & African Region, cloud DevOps Dubai, VPS hosting Middle East & African Region, cybersecurity Dubai, IT company Middle East & African Region, Tech Zone FZC" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AE" />
        <meta property="og:url" content="https://www.techzoneuae.com" />
        <meta property="og:site_name" content="Tech Zone FZC" />
        <meta property="og:title" content="Tech Zone FZC — IT Products & Services Dubai, UAE" />
        <meta property="og:description" content="Certified IT solutions in Dubai & UAE: Web Development, Cloud & DevOps, VPS Hosting, Server Management, AI & Data, Cybersecurity." />
        <meta property="og:image" content="https://www.techzoneuae.com/assets/images/og-image.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Tech Zone FZC — IT Products & Services Dubai, UAE" />
        <meta name="twitter:description" content="Certified IT solutions in Dubai & UAE: Web Development, Cloud & DevOps, VPS Hosting, Server Management, AI & Data, Cybersecurity." />
        <meta name="twitter:image" content="https://www.techzoneuae.com/assets/images/og-image.jpg" />
        <meta name="twitter:creator" content="@techzoneuae" />
        <link rel="canonical" href="https://www.techzoneuae.com" />
      </Helmet>

      <section className="slider slider-1">
        <div className="ebl-data-blocks-slider slider-body">
          <div className="slider-body-item block-item">
            <div className="hero-slider mySwiper swiper-initialized swiper-backface-hidden">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <div className="slide-inner">
                    <div className="slide_img">
                      <div className="slide_img_container"
                        style={{ backgroundImage: "url('/assets/images/photo-1451187580459-43490279c0fa.jpg')" }}
                        data-src="/assets/images/photo-1451187580459-43490279c0fa.jpg"></div>
                      <div className="anim-35 bg-effect">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="ebl-data-blocks">
                            <div className="comingsoon-body-item block-item slider-item animate">
                              <div className="subtitle rtr">
                                <h4>
                                  <span className="subtitle-first-span"></span>
                                  <span className="subtitle-middle-span">WELCOME TO TECH ZONE FZC</span>
                                  <span className="subtitle-last-span"></span>
                                </h4>
                              </div>
                            </div>
                            <div className="comingsoon-body-item block-item slider-item animate">
                              <div className="title rtr">
                                <h2>
                                  <span></span>
                                  <span>Enterprise Software &amp; Cloud Solutions</span>
                                  <span></span>
                                </h2>
                              </div>
                            </div>
                            <div className="comingsoon-body-item block-item slider-item animate">
                              <div className="plain_text rtr">
                                <p>
                                  Custom applications, high-performance hosting, automated cloud networks,
                                  and expert IT consulting tailored to your enterprise needs in the UAE.
                                </p>
                              </div>
                            </div>
                            <div className="comingsoon-body-item block-item slider-item animate">
                              <div className="button_list rtr-loop">
                                <a href="#services" className="btn-common primary-btn global-btn-style">
                                  <span>Our Services</span>
                                </a>
                                <a href="/contact" className="btn-common secondary-btn global-btn-style">
                                  <span>Contact Us</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="slide-inner">
                    <div className="slide_img">
                      <div className="slide_img_container"
                        style={{ backgroundImage: "url('/assets/images/photo-1555066931-4365d14bab8c.jpg')" }}
                        data-src="/assets/images/photo-1555066931-4365d14bab8c.jpg"></div>
                      <div className="bg-effect">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="slider-content-wrap">
                            <div className="comingsoon-body-item block-item slider-item animate">
                              <div className="subtitle rtr">
                                <h4>
                                  <span className="subtitle-first-span"></span>
                                  <span className="subtitle-middle-span">CUTTING-EDGE INNOVATION</span>
                                  <span className="subtitle-last-span"></span>
                                </h4>
                              </div>
                            </div>
                            <div className="comingsoon-body-item block-item slider-item animate">
                              <div className="title rtr">
                                <h2>
                                  <span></span>
                                  <span>Bespoke Web &amp; App Development</span>
                                  <span></span>
                                </h2>
                              </div>
                            </div>
                            <div className="comingsoon-body-item block-item slider-item animate">
                              <div className="plain_text rtr">
                                <p>
                                  We design and build fast, responsive, and secure web applications
                                  and mobile apps to drive your digital transformation and growth.
                                </p>
                              </div>
                            </div>
                            <div className="comingsoon-body-item block-item slider-item animate">
                              <div className="button_list rtr-loop">
                                <a href="#services" className="btn-common primary-btn global-btn-style">
                                  <span>Our Services</span>
                                </a>
                                <a href="tel:+971502424117" className="btn-common secondary-btn global-btn-style">
                                  <span>Call Now</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="swiper-slide">
                  <div className="slide-inner">
                    <div className="slide_img">
                      <div className="slide_img_container"
                        style={{ backgroundImage: "url('/assets/images/photo-1600132806370-bf17e65e942f.jpg')" }}
                        data-src="/assets/images/photo-1600132806370-bf17e65e942f.jpg"></div>
                      <div className="bg-effect">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="slider-content-wrap">
                            <div className="comingsoon-body-item block-item slider-item animate">
                              <div className="subtitle rtr">
                                <h4>
                                  <span className="subtitle-first-span"></span>
                                  <span className="subtitle-middle-span">SECURE &amp; SCALABLE CLOUD</span>
                                  <span className="subtitle-last-span"></span>
                                </h4>
                              </div>
                            </div>
                            <div className="comingsoon-body-item block-item slider-item animate">
                              <div className="title rtr">
                                <h2>
                                  <span></span>
                                  <span>Managed Infrastructure &amp; Hosting</span>
                                  <span></span>
                                </h2>
                              </div>
                            </div>
                            <div className="comingsoon-body-item block-item slider-item animate">
                              <div className="plain_text rtr">
                                <p>
                                  From automated cloud migrations and DevOps orchestration to high-speed
                                  virtual server deployment and 24/7 proactive monitoring.
                                </p>
                              </div>
                            </div>
                            <div className="comingsoon-body-item block-item slider-item animate">
                              <div className="button_list rtr-loop">
                                <a href="/about" className="btn-common primary-btn global-btn-style">
                                  <span>Learn More</span>
                                </a>
                                <a href="#" className="btn-common secondary-btn global-btn-style get-quote-btn">
                                  <span>Get A Quote</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-navigation horizontal vertical-left">
                <div className="swiper-button-next btn-next-prev swiper-navigation-style">
                  <span></span>
                  <span className="next-arrow-icon"><i className="fa fa-arrow-right"></i>
                  </span>
                </div>
                <div className="swiper-button-prev btn-next-prev swiper-navigation-style">
                  <span></span>
                  <span className="prev-arrow-icon"><i className="fa fa-arrow-left"></i>
                  </span>
                </div>
              </div>
              <div
                className="swiper-pagination horizontal bottom-right swiper-pagination-clickable swiper-pagination-bullets">
                <span className="swiper-pagination-bullet swiper-pagination-bullet-active" tabIndex="0" role="button"
                  aria-label="Go to slide 1" aria-current="true"></span><span className="swiper-pagination-bullet"
                    tabIndex="0" role="button" aria-label="Go to slide 2"></span><span className="swiper-pagination-bullet"
                      tabIndex="0" role="button" aria-label="Go to slide 3"></span>
              </div>
              <div className="slider-social vertical-right">
                <a href="https://www.facebook.com/techzoneuae" target="_blank" rel="noopener noreferrer"><i className="jsocial-facebook"></i></a>
                <a href="#"><i className="jsocial-x"></i></a>
                <a href="#"><i className="jsocial-linkedin"></i></a>
                <a href="https://dubai.dubizzle.com/community/web-computer-services/website-and-app-development-services/2026/6/30/professional-business-e-commerce-website-software-development---5b2c6915f9924ea4a1c51aa17a3ed0de/" target="_blank" rel="noopener noreferrer" title="Dubizzle">
                  <img src="/assets/img/social/dubizzle.png" alt="Dubizzle" style={{ width: "20px", height: "auto" }} />
                </a>
              </div>
              <span className="swiper-notification" aria-live="assertive" aria-atomic="true"></span><span
                className="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
            </div>
          </div>
        </div>
      </section>



      <section id="about" className="about-us-1 pt-60 pb-60">

        <div className="section-bg-images">
          <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/42-hexagon.svg')" }} data-aos="fade-up" data-aos-delay="100" data-aos-duration="800"></div>
          <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/31-star-5point.svg')" }} data-aos="fade-down" data-aos-delay="200" data-aos-duration="1000"></div>
          <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/11-circle-basic.svg')" }} data-aos="fade-left" data-aos-delay="300" data-aos-duration="1200"></div>
          <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/75-shield.svg')" }} data-aos="fade-right" data-aos-delay="400" data-aos-duration="1400"></div>
          <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/95-layered-circles.svg')" }} data-aos="zoom-in" data-aos-delay="500" data-aos-duration="800"></div>
          <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/63-diamond.svg')" }} data-aos="zoom-out" data-aos-delay="600" data-aos-duration="1000"></div>
          <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/83-rounded-squircle.svg')" }} data-aos="flip-left" data-aos-delay="700" data-aos-duration="1200"></div>
          <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/89-gear.svg')" }} data-aos="flip-right" data-aos-delay="800" data-aos-duration="1400"></div>
          <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/47-hexagon-outline.svg')" }} data-aos="flip-up" data-aos-delay="900" data-aos-duration="800"></div>
        </div>
        <div className="container">
          <div className="row align-items-center flex-row-reverse">
            <div className="col-lg-6">
              <div className="ebl-data-blocks">
                <div className="comingsoon-body-item block-item" data-aos="flip-left" data-aos-delay="100">
                  <div className="subtitle subtitle_1bececf">
                    <h4>
                      <span className="subtitle-first-span"></span>
                      <span className="subtitle-middle-span">About Us</span>
                      <span className="subtitle-last-span"></span>
                    </h4>
                  </div>
                </div>
                <div className="comingsoon-body-item block-item" data-aos="flip-right" data-aos-delay="200">
                  <div className="title title_1bececf">
                    <h2>
                      <span></span>
                      <span>Your Trusted Partner for Digital Transformation in
                        UAE</span>
                      <span></span>
                    </h2>
                  </div>
                </div>
                <div className="comingsoon-body-item block-item" data-aos="flip-left" data-aos-delay="300">
                  <div className="plain_text plain_text_1bececf">
                    <p>
                      Tech Zone FZC is a leading provider of comprehensive IT products and services
                      in the Middle East & African Region. With a certified team of developers, cloud architects,
                      and cybersecurity specialists, we deliver cutting-edge technology solutions
                      that power business success and scale operations.
                    </p>
                  </div>
                </div>
                <div className="comingsoon-body-item block-item" data-aos="flip-right" data-aos-delay="400">
                  <div className="common_list">
                    <div className="list-item-wrap">
                      <ul className="common-list-ul">
                        <li className="common_list_item">
                          <span>
                            <i className="fa fa-check-circle"></i>
                          </span>
                          <span>Certified IT Experts</span>
                        </li>
                        <li className="common_list_item">
                          <span>
                            <i className="fa fa-check-circle"></i>
                          </span>
                          <span>Scalable Architectures</span>
                        </li>
                        <li className="common_list_item">
                          <span>
                            <i className="fa fa-check-circle"></i>
                          </span>
                          <span>24/7 Server Monitoring</span>
                        </li>
                        <li className="common_list_item">
                          <span>
                            <i className="fa fa-check-circle"></i>
                          </span>
                          <span>Robust Security Protocols</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="img-relative text-start single-img-wrapper" data-aos="flip-left" data-aos-delay="300">
                <div className="img-anim-one bg-img-effect">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <a href="#"><img src="/assets/images/photo-1522071820081-009f0129c71c.jpg"
                  alt="Tech Zone FZC Developer Team" /></a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="skills-1 pt-60 pb-60">

        <div className="section-bg-images">
          <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/12-circle-outline.svg')" }} data-aos="fade-right" data-aos-delay="100" data-aos-duration="800"></div>
          <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/85-wave.svg')" }} data-aos="zoom-in" data-aos-delay="200" data-aos-duration="1000"></div>
          <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/64-diamond-outline.svg')" }} data-aos="zoom-out" data-aos-delay="300" data-aos-duration="1200"></div>
          <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/87-trophy.svg')" }} data-aos="flip-left" data-aos-delay="400" data-aos-duration="1400"></div>
          <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/96-hexagon-badge.svg')" }} data-aos="flip-right" data-aos-delay="500" data-aos-duration="800"></div>
          <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/20-circle-ring.svg')" }} data-aos="flip-up" data-aos-delay="600" data-aos-duration="1000"></div>
          <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/48-octagon-outline.svg')" }} data-aos="flip-down" data-aos-delay="700" data-aos-duration="1200"></div>
          <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/40-star-sparkle.svg')" }} data-aos="rotate-left" data-aos-delay="800" data-aos-duration="1400"></div>
          <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/50-hexagon-flat.svg')" }} data-aos="rotate-right" data-aos-delay="900" data-aos-duration="800"></div>
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="ebl-data-blocks">
                <div className="comingsoon-body-item block-item" data-aos="flip-left" data-aos-delay="100">
                  <div className="subtitle subtitle_1bececf">
                    <h4>
                      <span className="subtitle-first-span"></span>
                      <span className="subtitle-middle-span">Our Expertise</span>
                      <span className="subtitle-last-span"></span>
                    </h4>
                  </div>
                </div>
                <div className="comingsoon-body-item block-item" data-aos="flip-right" data-aos-delay="200">
                  <div className="title title_1bececf">
                    <h2>
                      <span></span>
                      <span>Industry-Leading Technical Expertise</span>
                      <span></span>
                    </h2>
                  </div>
                </div>
                <div className="comingsoon-body-item block-item" data-aos="flip-left" data-aos-delay="300">
                  <div className="plain_text plain_text_1bececf">
                    <p>
                      Our technical team holds certifications from top cloud providers and technology partners,
                      delivering high-availability solutions for complex systems and enterprise web architectures.
                    </p>
                  </div>
                </div>
                <div className="comingsoon-body-item block-item" data-aos="flip-right" data-aos-delay="400">
                  <div className="skills_list">
                    <ul className="common-list-ul">
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>Web &amp; App Development</h5>
                          <h6>95%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "95%" }} aria-valuenow="95"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>Cloud &amp; DevOps</h5>
                          <h6>92%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "92%" }} aria-valuenow="92"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>UI/UX Product Design</h5>
                          <h6>90%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "90%" }} aria-valuenow="90"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>VPS &amp; Cloud Platforms</h5>
                          <h6>93%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "93%" }} aria-valuenow="93"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>Server Management</h5>
                          <h6>91%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "91%" }} aria-valuenow="91"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>AI &amp; Data Solutions</h5>
                          <h6>87%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "87%" }} aria-valuenow="87"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>Cybersecurity Audits</h5>
                          <h6>94%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "94%" }} aria-valuenow="94"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                      <li className="common_list_item">
                        <div className="d-flex justify-content-between mb-2">
                          <h5>System Migration</h5>
                          <h6>89%</h6>
                        </div>
                        <div className="progress">
                          <div className="progress-bar" role="progressbar" style={{ width: "89%" }} aria-valuenow="89"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="img-relative text-start single-img-wrapper" data-aos="flip-left" data-aos-delay="300">
                <div className="img-anim-one bg-img-effect">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <a href="#"><img src="/assets/img/tech_expertise_shape.png"
                  alt="Tech Zone FZC UI/UX Design &amp; Development" /></a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="service-1">

        <div className="section-bg-images">
          <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/89-gear.svg')" }} data-aos="flip-left" data-aos-delay="100" data-aos-duration="800"></div>
          <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/15-circle-gradient.svg')" }} data-aos="flip-right" data-aos-delay="200" data-aos-duration="1000"></div>
          <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/44-octagon.svg')" }} data-aos="flip-up" data-aos-delay="300" data-aos-duration="1200"></div>
          <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/92-infinity.svg')" }} data-aos="flip-down" data-aos-delay="400" data-aos-duration="1400"></div>
          <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/94-star-badge.svg')" }} data-aos="rotate-left" data-aos-delay="500" data-aos-duration="800"></div>
          <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/88-bell.svg')" }} data-aos="rotate-right" data-aos-delay="600" data-aos-duration="1000"></div>
          <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/99-semicircle.svg')" }} data-aos="fade-up" data-aos-delay="700" data-aos-duration="1200"></div>
          <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/77-badge.svg')" }} data-aos="fade-down" data-aos-delay="800" data-aos-duration="1400"></div>
          <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/83-rounded-squircle.svg')" }} data-aos="fade-left" data-aos-delay="900" data-aos-duration="800"></div>
        </div>
        <div className="container">

          <div className="ebl-data-blocks">
            <div className="comingsoon-body-item block-item  text-center" data-aos="fade-down" data-aos-delay="100">
              <div className="subtitle subtitle_1bececf">
                <h4>
                  <span className="subtitle-first-span"></span>
                  <span className="subtitle-middle-span">What We Offer</span>
                  <span className="subtitle-last-span"></span>
                </h4>
              </div>
            </div>
            <div className="comingsoon-body-item block-item  text-center" data-aos="fade-down" data-aos-delay="200">
              <div className="title title_1bececf">
                <h2>
                  <span></span>
                  <span>Services We Offer</span>
                  <span></span>
                </h2>
              </div>
            </div>
            <div className="comingsoon-body-item block-item  text-center" data-aos="fade-down" data-aos-delay="300">
              <div className="plain_text plain_text_1bececf">
                <p>
                  From custom web development to secure cloud architectures, we offer comprehensive IT services
                  tailored to drive digital growth and operational efficiency in the UAE.
                </p>
              </div>
            </div>
            <div className="comingsoon-body-item block-item">
              <div className="service_list">
                <div className="service_wrap swiper service-swiper">
                  <div className="jt-row swiper-wrapper">

                    <div className="jt-col-3 swiper-slide" data-aos="flip-left" data-aos-delay="100">
                      <div className="service-item">
                        <div className="service-figure middle-right">
                          <img
                            src="/assets/images/photo-1498050108023-c5249f4df085.jpg"
                            alt="Web &amp; App Development" />
                        </div>
                        <div className="service-box-content">
                          <div className="service-content">
                            <div className="icon">
                              <i className="fas fa-laptop-code"></i>
                            </div>
                            <div className="service-text-content">
                              <div className="service-title">
                                <h3 className="">
                                  <a href="/services/web-app-development">Web &amp; App Dev</a>
                                </h3>
                              </div>
                              <p>
                                Custom front-end and back-end web applications, SaaS platforms, and mobile apps built to scale.
                              </p>
                              <div className="service-button">
                                <a className="btn-service" href="/services/web-app-development">
                                  <span className="bar"></span>
                                  <span>Learn More</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="hover-content">
                          <div className="hover-content-inner">
                            <div className="hover-content-text">
                              <h3><a href="/services/web-app-development">Web &amp; App Development</a></h3>
                              <p>
                                We design and build custom web portals, mobile apps (iOS &amp; Android), and robust SaaS platforms using React, Next.js, Flutter, and Node.js for modern enterprises.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="jt-col-3 swiper-slide" data-aos="flip-right" data-aos-delay="200">
                      <div className="service-item">
                        <div className="service-figure middle-right">
                          <img
                            src="/assets/images/photo-1561070791-2526d30994b5.jpg"
                            alt="UI/UX Design" />
                        </div>
                        <div className="service-box-content">
                          <div className="service-content">
                            <div className="icon">
                              <i className="fas fa-palette"></i>
                            </div>
                            <div className="service-text-content">
                              <div className="service-title">
                                <h3 className="">
                                  <a href="/services/ui-ux-design">UI/UX Design</a>
                                </h3>
                              </div>
                              <p>
                                Intuitive and beautiful user interfaces and user experiences designed to maximize engagement.
                              </p>
                              <div className="service-button">
                                <a className="btn-service" href="/services/ui-ux-design">
                                  <span className="bar"></span>
                                  <span>Learn More</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="hover-content">
                          <div className="hover-content-inner">
                            <div className="hover-content-text">
                              <h3><a href="/services/ui-ux-design">UI/UX Design</a></h3>
                              <p>
                                User-centric research, wireframing, high-fidelity prototyping, and interactive design to create seamless, visually stunning digital products.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="jt-col-3 swiper-slide" data-aos="flip-left" data-aos-delay="300">
                      <div className="service-item">
                        <div className="service-figure middle-right">
                          <img
                            src="/assets/images/photo-1451187580459-43490279c0fa.jpg"
                            alt="Cloud &amp; DevOps" />
                        </div>
                        <div className="service-box-content">
                          <div className="service-content">
                            <div className="icon">
                              <i className="fas fa-cloud"></i>
                            </div>
                            <div className="service-text-content">
                              <div className="service-title">
                                <h3 className="">
                                  <a href="/services/cloud-devops">Cloud &amp; DevOps</a>
                                </h3>
                              </div>
                              <p>
                                CI/CD pipelines, containerization with Docker and Kubernetes, and automated infrastructure.
                              </p>
                              <div className="service-button">
                                <a className="btn-service" href="/services/cloud-devops">
                                  <span className="bar"></span>
                                  <span>Learn More</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="hover-content">
                          <div className="hover-content-inner">
                            <div className="hover-content-text">
                              <h3><a href="/services/cloud-devops">Cloud &amp; DevOps Services</a></h3>
                              <p>
                                We streamline your deployments with automated CI/CD pipelines, secure Kubernetes container orchestration, and Infrastructure as Code (IaC) architectures.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="jt-col-3 swiper-slide" data-aos="flip-right" data-aos-delay="400">
                      <div className="service-item">
                        <div className="service-figure middle-right">
                          <img
                            src="/assets/images/photo-1558494949-ef010cbdcc31.jpg"
                            alt="VPS &amp; Hosting" />
                        </div>
                        <div className="service-box-content">
                          <div className="service-content">
                            <div className="icon">
                              <i className="fas fa-server"></i>
                            </div>
                            <div className="service-text-content">
                              <div className="service-title">
                                <h3 className="">
                                  <a href="/services/vps-hosting">VPS &amp; Hosting</a>
                                </h3>
                              </div>
                              <p>
                                High-performance virtual private servers with 99.9% uptime, dedicated resources, and DDoS protection.
                              </p>
                              <div className="service-button">
                                <a className="btn-service" href="/services/vps-hosting">
                                  <span className="bar"></span>
                                  <span>Learn More</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="hover-content">
                          <div className="hover-content-inner">
                            <div className="hover-content-text">
                              <h3><a href="/services/vps-hosting">VPS &amp; Hosting Solutions</a></h3>
                              <p>
                                Get lightning-fast VPS hosting with NVMe SSD storage, automated daily backups, scalability options, and robust server firewall setups.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="jt-col-3 swiper-slide" data-aos="flip-left" data-aos-delay="500">
                      <div className="service-item">
                        <div className="service-figure middle-right">
                          <img
                            src="/assets/images/photo-1451187580459-43490279c0fa.jpg"
                            alt="AWS &amp; Cloud Platforms" />
                        </div>
                        <div className="service-box-content">
                          <div className="service-content">
                            <div className="icon">
                              <i className="fab fa-aws"></i>
                            </div>
                            <div className="service-text-content">
                              <div className="service-title">
                                <h3 className="">
                                  <a href="/services/aws-cloud-platforms">AWS &amp; Cloud</a>
                                </h3>
                              </div>
                              <p>
                                Architecting and managing secure, scalable environments on AWS, Azure, and Google Cloud.
                              </p>
                              <div className="service-button">
                                <a className="btn-service" href="/services/aws-cloud-platforms">
                                  <span className="bar"></span>
                                  <span>Learn More</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="hover-content">
                          <div className="hover-content-inner">
                            <div className="hover-content-text">
                              <h3><a href="/services/aws-cloud-platforms">AWS &amp; Cloud Platforms</a></h3>
                              <p>
                                Professional cloud consulting and migration services. We design resilient multi-region architectures, serverless backends, and cost-optimized setups.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="jt-col-3 swiper-slide" data-aos="flip-right" data-aos-delay="600">
                      <div className="service-item">
                        <div className="service-figure middle-right">
                          <img
                            src="/assets/images/photo-1600132806370-bf17e65e942f.jpg"
                            alt="Server Management" />
                        </div>
                        <div className="service-box-content">
                          <div className="service-content">
                            <div className="icon">
                              <i className="fas fa-tasks"></i>
                            </div>
                            <div className="service-text-content">
                              <div className="service-title">
                                <h3 className="">
                                  <a href="/services/server-management">Server Mgmt</a>
                                </h3>
                              </div>
                              <p>
                                Proactive server administration, patching, OS updates, backups, and 24/7 health monitoring.
                              </p>
                              <div className="service-button">
                                <a className="btn-service" href="/services/server-management">
                                  <span className="bar"></span>
                                  <span>Learn More</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="hover-content">
                          <div className="hover-content-inner">
                            <div className="hover-content-text">
                              <h3><a href="/services/server-management">Server Management Services</a></h3>
                              <p>
                                Full administration of Linux and Windows servers. We handle security updates, hardware tuning, emergency recovery, and proactive load balancing.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="jt-col-3 swiper-slide" data-aos="flip-left" data-aos-delay="700">
                      <div className="service-item">
                        <div className="service-figure middle-right">
                          <img
                            src="/assets/images/photo-1507146426996-ef05306b995a.jpg"
                            alt="AI &amp; Data" />
                        </div>
                        <div className="service-box-content">
                          <div className="service-content">
                            <div className="icon">
                              <i className="fas fa-brain"></i>
                            </div>
                            <div className="service-text-content">
                              <div className="service-title">
                                <h3 className="">
                                  <a href="/services/ai-data">AI &amp; Data</a>
                                </h3>
                              </div>
                              <p>
                                Machine learning integrations, big data processing pipelines, and intelligence tools.
                              </p>
                              <div className="service-button">
                                <a className="btn-service" href="/services/ai-data">
                                  <span className="bar"></span>
                                  <span>Learn More</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="hover-content">
                          <div className="hover-content-inner">
                            <div className="hover-content-text">
                              <h3><a href="/services/ai-data">AI &amp; Data Solutions</a></h3>
                              <p>
                                Harness the power of your data with custom machine learning models, ETL data pipelines, predictive analytics, and executive business dashboards.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="jt-col-3 swiper-slide" data-aos="flip-right" data-aos-delay="800">
                      <div className="service-item">
                        <div className="service-figure middle-right">
                          <img
                            src="/assets/images/photo-1550751827-4bd374c3f58b.jpg"
                            alt="Cybersecurity" />
                        </div>
                        <div className="service-box-content">
                          <div className="service-content">
                            <div className="icon">
                              <i className="fas fa-shield-alt"></i>
                            </div>
                            <div className="service-text-content">
                              <div className="service-title">
                                <h3 className="">
                                  <a href="/services/cybersecurity">Cybersecurity</a>
                                </h3>
                              </div>
                              <p>
                                Threat assessments, firewall configurations, penetration testing, and security systems.
                              </p>
                              <div className="service-button">
                                <a className="btn-service" href="/services/cybersecurity">
                                  <span className="bar"></span>
                                  <span>Learn More</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="hover-content">
                          <div className="hover-content-inner">
                            <div className="hover-content-text">
                              <h3><a href="/services/cybersecurity">Cybersecurity Services</a></h3>
                              <p>
                                Comprehensive enterprise protection. We conduct vulnerability scanning, implement Zero-Trust policies, handle firewall setups, and provide encryption audits.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </section>


      <section id="products" className="products-section pt-60 pb-60" style={{ backgroundColor: "#f8f9fb", position: "relative", overflow: "hidden" }}>
        <div className="container">
          <div className="ebl-data-blocks">
            <div className="comingsoon-body-item block-item text-center" data-aos="fade-down" data-aos-delay="100">
              <div className="subtitle subtitle_1bececf">
                <h4>
                  <span className="subtitle-first-span"></span>
                  <span className="subtitle-middle-span">Enterprise Solutions</span>
                  <span className="subtitle-last-span"></span>
                </h4>
              </div>
            </div>
            <div className="comingsoon-body-item block-item text-center" data-aos="fade-down" data-aos-delay="200">
              <div className="title title_1bececf">
                <h2>
                  <span></span>
                  <span>Our Premium IT Products</span>
                  <span></span>
                </h2>
              </div>
            </div>
            <div className="comingsoon-body-item block-item text-center mb-5" data-aos="fade-down" data-aos-delay="300">
              <div className="plain_text plain_text_1bececf">
                <p>
                  In addition to our bespoke services, we offer ready-to-deploy enterprise software and infrastructure products built for security, scalability, and performance.
                </p>
              </div>
            </div>
          </div>

          <div className="row">

            <div className="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="100" id="products-software">
              <div className="card border-0 shadow-sm h-100" style={{ borderRadius: "20px", overflow: "hidden", background: "#fff", transition: "transform 0.3s", boxShadow: "0 4px 20px rgba(0,0,0,0.05) !important" }}>
                <img src="/assets/images/photo-1551288049-bebda4e38f71.jpg" className="card-img-top" alt="CRM & ERP Solutions" />
                <div className="card-body p-4 d-flex flex-column">
                  <span className="badge mb-2" style={{ backgroundColor: "var(--color-primary)", color: "#fff", alignSelf: "flex-start", borderRadius: "100px", padding: "6px 12px", fontWeight: "500", fontSize: "0.8rem" }}>SOFTWARE SOLUTIONS</span>
                  <h3 className="card-title h5 font-weight-bold" style={{ color: "#1a1a2e", marginBottom: "0.8rem", fontFamily: "'Barlow', sans-serif" }}>Enterprise CRM &amp; ERP Suite</h3>
                  <p className="card-text text-muted" style={{ fontSize: "0.92rem", lineHeight: "1.6", flexGrow: "1" }}>A complete business management dashboard integrating pipeline sales, human resources, payroll tracking, inventory flow, automated invoices, and financial reports.</p>
                  <Link to="/products/software-solutions" className="global-btn-style btn-common primary-btn mt-3" style={{ display: "block", textAlign: "center" }}><span></span><span>View Product</span><span></span></Link>
                </div>
              </div>
            </div>


            <div className="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="200" id="products-infrastructure">
              <div className="card border-0 shadow-sm h-100" style={{ borderRadius: "20px", overflow: "hidden", background: "#fff", transition: "transform 0.3s", boxShadow: "0 4px 20px rgba(0,0,0,0.05) !important" }}>
                <img src="/assets/images/photo-1558494949-ef010cbdcc31.jpg" className="card-img-top" alt="Managed Dedicated Servers" />
                <div className="card-body p-4 d-flex flex-column">
                  <span className="badge mb-2" style={{ backgroundColor: "var(--color-primary)", color: "#fff", alignSelf: "flex-start", borderRadius: "100px", padding: "6px 12px", fontWeight: "500", fontSize: "0.8rem" }}>INFRASTRUCTURE</span>
                  <h3 className="card-title h5 font-weight-bold" style={{ color: "#1a1a2e", marginBottom: "0.8rem", fontFamily: "'Barlow', sans-serif" }}>High-Performance VPS Clusters</h3>
                  <p className="card-text text-muted" style={{ fontSize: "0.92rem", lineHeight: "1.6", flexGrow: "1" }}>Enterprise-grade virtual servers with automatic scaling, SSD NVMe storage, daily backups, standard DDoS filtering, and full SSH root access control.</p>
                  <Link to="/products/infrastructure-servers" className="global-btn-style btn-common primary-btn mt-3" style={{ display: "block", textAlign: "center" }}><span></span><span>View Details</span><span></span></Link>
                </div>
              </div>
            </div>


            <div className="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="300" id="products-cloud">
              <div className="card border-0 shadow-sm h-100" style={{ borderRadius: "20px", overflow: "hidden", background: "#fff", transition: "transform 0.3s", boxShadow: "0 4px 20px rgba(0,0,0,0.05) !important" }}>
                <img src="/assets/images/photo-1451187580459-43490279c0fa.jpg" className="card-img-top" alt="Cloud SaaS Subscriptions" />
                <div className="card-body p-4 d-flex flex-column">
                  <span className="badge mb-2" style={{ backgroundColor: "var(--color-primary)", color: "#fff", alignSelf: "flex-start", borderRadius: "100px", padding: "6px 12px", fontWeight: "500", fontSize: "0.8rem" }}>CLOUD SaaS</span>
                  <h3 className="card-title h5 font-weight-bold" style={{ color: "#1a1a2e", marginBottom: "0.8rem", fontFamily: "'Barlow', sans-serif" }}>AWS Managed Subscriptions</h3>
                  <p className="card-text text-muted" style={{ fontSize: "0.92rem", lineHeight: "1.6", flexGrow: "1" }}>Ready-to-use cloud infrastructure pre-packaged with auto-scaling, serverless backend functions, database triggers, and 24/7 technical operations management.</p>
                  <Link to="/products/cloud-saas-product" className="global-btn-style btn-common primary-btn mt-3" style={{ display: "block", textAlign: "center" }}><span></span><span>View Subscriptions</span><span></span></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="gallery" className="gallery-1 gallery-no-slider pt-60 pb-60">

        <div className="section-bg-images">
          <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/63-diamond.svg')" }} data-aos="flip-down" data-aos-delay="100" data-aos-duration="800"></div>
          <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/74-drop.svg')" }} data-aos="rotate-left" data-aos-delay="200" data-aos-duration="1000"></div>
          <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/42-hexagon.svg')" }} data-aos="rotate-right" data-aos-delay="300" data-aos-duration="1200"></div>
          <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/90-home.svg')" }} data-aos="fade-up" data-aos-delay="400" data-aos-duration="1400"></div>
          <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/95-layered-circles.svg')" }} data-aos="fade-down" data-aos-delay="500" data-aos-duration="800"></div>
          <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/91-eye.svg')" }} data-aos="fade-left" data-aos-delay="600" data-aos-duration="1000"></div>
          <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/47-hexagon-outline.svg')" }} data-aos="fade-right" data-aos-delay="700" data-aos-duration="1200"></div>
          <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/84-rounded-leaf.svg')" }} data-aos="zoom-in" data-aos-delay="800" data-aos-duration="1400"></div>
          <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/12-circle-outline.svg')" }} data-aos="zoom-out" data-aos-delay="900" data-aos-duration="800"></div>
        </div>
        <div className="container">

          <div className="ebl-data-blocks">
            <div className="comingsoon-body-item block-item text-center" data-aos="fade-down" data-aos-delay="100">
              <div className="subtitle">
                <h4>
                  <span></span>
                  <span>Our Portfolio</span>
                  <span></span>
                </h4>
              </div>
            </div>
            <div className="comingsoon-body-item block-item text-center" data-aos="fade-down" data-aos-delay="200">
              <div className="title title_1bececf">
                <h2>
                  <span></span>
                  <span>Recent Projects & Completed Work</span>
                  <span></span>
                </h2>
              </div>
            </div>

            <div className="comingsoon-body-item block-item text-center" data-aos="fade-down" data-aos-delay="300">
              <div className="plain_text plain_text_1bececf">
                <p>
                  Take a look at our portfolio of completed projects showcasing our
                  quality execution across web applications, cloud hosting, and enterprise integrations.
                </p>
              </div>
            </div>

            <div className="comingsoon-body-item block-item mt-3">
              <div className="gallery">
                <div className="gallery_grid swiper gallery-swiper">
                  <div className="swiper-wrapper row">
                    <div className="swiper-slide col-lg-4 col-sm-6" data-aos="flip-left" data-aos-delay="100">
                      <div className="gallery_single">
                        <div className="gallery_img">
                          <img
                            src="/assets/images/photo-1460925895917-afdab827c52f.jpg"
                            alt="FinTech Web App" />
                        </div>
                        <div className="gallery_overlay">
                          <h3><a href="#">FinTech Web App</a></h3>
                          <div className="gal-cat">Web &amp; App</div>
                          <div className="item-btn">
                            <a href="/assets/images/photo-1460925895917-afdab827c52f.jpg"
                              className="btn_gallery">+</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide col-lg-4 col-sm-6" data-aos="flip-right" data-aos-delay="200">
                      <div className="gallery_single">
                        <div className="gallery_img">
                          <img
                            src="/assets/images/photo-1512941937669-90a1b58e7e9c.jpg"
                            alt="E-Commerce App UX" />
                        </div>
                        <div className="gallery_overlay">
                          <h3><a href="#">E-Commerce App UX</a></h3>
                          <div className="gal-cat">UI/UX Design</div>
                          <div className="item-btn">
                            <a href="/assets/images/photo-1512941937669-90a1b58e7e9c.jpg"
                              className="btn_gallery">+</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide col-lg-4 col-sm-6" data-aos="flip-left" data-aos-delay="300">
                      <div className="gallery_single">
                        <div className="gallery_img">
                          <img
                            src="/assets/images/photo-1551288049-bebda4e38f71.jpg"
                            alt="AWS Cloud Migration" />
                        </div>
                        <div className="gallery_overlay">
                          <h3><a href="#">AWS Cloud Migration</a></h3>
                          <div className="gal-cat">Cloud &amp; DevOps</div>
                          <div className="item-btn">
                            <a href="/assets/images/photo-1551288049-bebda4e38f71.jpg"
                              className="btn_gallery">+</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide col-lg-4 col-sm-6" data-aos="flip-right" data-aos-delay="400">
                      <div className="gallery_single">
                        <div className="gallery_img">
                          <img
                            src="/assets/images/photo-1563986768609-322da13575f3.jpg"
                            alt="Security Audit" />
                        </div>
                        <div className="gallery_overlay">
                          <h3><a href="#">Security Audit</a></h3>
                          <div className="gal-cat">Cybersecurity</div>
                          <div className="item-btn">
                            <a href="/assets/images/photo-1563986768609-322da13575f3.jpg"
                              className="btn_gallery">+</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide col-lg-4 col-sm-6" data-aos="flip-left" data-aos-delay="500">
                      <div className="gallery_single">
                        <div className="gallery_img">
                          <img
                            src="/assets/images/photo-1544383835-bda2bc66a55d.jpg"
                            alt="Big Data Processing" />
                        </div>
                        <div className="gallery_overlay">
                          <h3><a href="#">Big Data Processing</a></h3>
                          <div className="gal-cat">AI &amp; Data</div>
                          <div className="item-btn">
                            <a href="/assets/images/photo-1544383835-bda2bc66a55d.jpg"
                              className="btn_gallery">+</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide col-lg-4 col-sm-6" data-aos="flip-right" data-aos-delay="600">
                      <div className="gallery_single">
                        <div className="gallery_img">
                          <img
                            src="/assets/images/photo-1558494949-ef010cbdcc31.jpg"
                            alt="High-Speed VPS Setup" />
                        </div>
                        <div className="gallery_overlay">
                          <h3><a href="#">High-Speed VPS Setup</a></h3>
                          <div className="gal-cat">Server Management</div>
                          <div className="item-btn">
                            <a href="/assets/images/photo-1558494949-ef010cbdcc31.jpg"
                              className="btn_gallery">+</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-navigation no-slider no-nav">
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-pagination"></div>
                    <div className="swiper-button-next"></div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>


      <section className="recent-work-1">

        <div className="section-bg-images">
          <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/75-shield.svg')" }} data-aos="fade-up" data-aos-delay="100" data-aos-duration="800"></div>
          <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/87-trophy.svg')" }} data-aos="fade-down" data-aos-delay="200" data-aos-duration="1000"></div>
          <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/44-octagon.svg')" }} data-aos="fade-left" data-aos-delay="300" data-aos-duration="1200"></div>
          <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/78-ribbon.svg')" }} data-aos="fade-right" data-aos-delay="400" data-aos-duration="1400"></div>
          <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/94-star-badge.svg')" }} data-aos="zoom-in" data-aos-delay="500" data-aos-duration="800"></div>
          <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/31-star-5point.svg')" }} data-aos="zoom-out" data-aos-delay="600" data-aos-duration="1000"></div>
          <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/20-circle-ring.svg')" }} data-aos="flip-left" data-aos-delay="700" data-aos-duration="1200"></div>
          <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/40-star-sparkle.svg')" }} data-aos="flip-right" data-aos-delay="800" data-aos-duration="1400"></div>
          <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/64-diamond-outline.svg')" }} data-aos="flip-up" data-aos-delay="900" data-aos-duration="800"></div>
        </div>
        <div className="container">
          <div className="comingsoon-body-item block-item mb-2 text-center" data-aos="fade-down" data-aos-delay="100">
            <div className="subtitle subtitle_1bececf">
              <h4>
                <span className="subtitle-first-span"></span>
                <span className="subtitle-middle-span">Featured Work</span>
                <span className="subtitle-last-span"></span>
              </h4>
            </div>
          </div>
          <div className="comingsoon-body-item block-item mb-2 text-center" data-aos="zoom-in" data-aos-delay="200">
            <div className="title title_1bececf">
              <h2>
                <span></span>
                <span>Our Signature Projects</span>
                <span></span>
              </h2>
            </div>
          </div>
          <div className="comingsoon-body-item block-item mb-4 text-center" data-aos="fade-up" data-aos-delay="300">
            <div className="plain_text plain_text_1bececf">
              <p>
                Explore our featured IT and cloud projects that showcase our expertise in enterprise system design, cloud modernization, and software engineering.
              </p>
            </div>
          </div>
          <div className="comingsoon-body-item block-item">
            <div className="recent-work">
              <div className="recent-work-wrap">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="row">
                      <div className="col-lg-6" data-aos="flip-left" data-aos-delay="200">
                        <div className="work-img work-img-1">
                          <img
                            src="/assets/images/photo-1460925895917-afdab827c52f.jpg"
                            alt="Enterprise ERP Implementation" />
                        </div>
                      </div>
                      <div className="col-lg-6" data-aos="fade-up" data-aos-delay="300">
                        <div className="work-box work-box-1">
                          <img src="/assets/img/logo-original.jpeg" alt="Tech Zone Logo" style={{ maxWidth: "150px", height: "auto" }} />
                          <div className="comingsoon-body-item block-item">
                            <div className="title title_1bececf">
                              <h2>
                                <span></span>
                                <span>Enterprise ERP Integration</span>
                                <span></span>
                              </h2>
                            </div>
                          </div>
                          <div className="comingsoon-body-item block-item">
                            <div className="plain_text plain_text_1bececf">
                              <p>
                                A full-scale ERP integration for a multi-national logistics company in the Middle East & African Region, optimizing human resources, inventory tracking, and supply chain management.
                              </p>
                            </div>
                          </div>
                          <a href="/gallery" className="btn-browse">View Project</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="row flex-row-reverse">
                      <div className="col-lg-6" data-aos="flip-right" data-aos-delay="200">
                        <div className="work-img">
                          <img
                            src="/assets/images/photo-1558494949-ef010cbdcc31.jpg"
                            alt="Cloud Infrastructure Modernization" />
                        </div>
                      </div>
                      <div className="col-lg-6" data-aos="zoom-in" data-aos-delay="300">
                        <div className="work-box">
                          <img src="/assets/img/logo-original.jpeg" alt="Tech Zone Logo" style={{ maxWidth: "150px", height: "auto" }} />
                          <div className="comingsoon-body-item block-item">
                            <div className="title title_1bececf">
                              <h2>
                                <span></span>
                                <span>Cloud Infrastructure Modernization</span>
                                <span></span>
                              </h2>
                            </div>
                          </div>
                          <div className="comingsoon-body-item block-item">
                            <div className="plain_text plain_text_1bececf">
                              <p>
                                Migrated a legacy e-commerce platform with over 100k daily active users to a high-availability AWS serverless architecture, reducing hosting costs by 40%.
                              </p>
                            </div>
                          </div>
                          <Link to="/gallery" className="btn-browse">View Project</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="why-choose-us pt-60 pb-60">

        <div className="section-bg-images">
          <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/95-layered-circles.svg')" }} data-aos="fade-right" data-aos-delay="100" data-aos-duration="800"></div>
          <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/83-rounded-squircle.svg')" }} data-aos="zoom-in" data-aos-delay="200" data-aos-duration="1000"></div>
          <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/11-circle-basic.svg')" }} data-aos="zoom-out" data-aos-delay="300" data-aos-duration="1200"></div>
          <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/63-diamond.svg')" }} data-aos="flip-left" data-aos-delay="400" data-aos-duration="1400"></div>
          <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/96-hexagon-badge.svg')" }} data-aos="flip-right" data-aos-delay="500" data-aos-duration="800"></div>
          <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/75-shield.svg')" }} data-aos="flip-up" data-aos-delay="600" data-aos-duration="1000"></div>
          <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/50-hexagon-flat.svg')" }} data-aos="flip-down" data-aos-delay="700" data-aos-duration="1200"></div>
          <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/89-gear.svg')" }} data-aos="rotate-left" data-aos-delay="800" data-aos-duration="1400"></div>
          <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/48-octagon-outline.svg')" }} data-aos="rotate-right" data-aos-delay="900" data-aos-duration="800"></div>
        </div>
        <div className="container">
          <div className="section-header">
            <div className="comingsoon-body-item block-item mb-2 text-center" data-aos="aos-blockRubberBand">
              <div className="subtitle subtitle_1bececf">
                <h4>
                  <span className="subtitle-first-span"></span>
                  <span className="subtitle-middle-span">Why Choose Us</span>
                  <span className="subtitle-last-span"></span>
                </h4>
              </div>
            </div>
            <div className="comingsoon-body-item block-item mb-2 text-center" data-aos="aos-blockRubberBand">
              <div className="title title_1bececf">
                <h2>
                  <span></span>
                  <span>What Makes Tech Zone Different</span>
                  <span></span>
                </h2>
              </div>
            </div>
            <div className="comingsoon-body-item block-item mb-4 text-center" data-aos="aos-blockRubberBand">
              <div className="plain_text plain_text_1bececf">
                <p>
                  Discover why leading businesses across the Middle East & African Regiontrust Tech Zone FZC for their critical IT products and services.
                </p>
              </div>
            </div>
          </div>

          <div className="row">

            <div className="col-lg-6 col-md-6 mb-30" data-aos="flip-left" data-aos-delay="200">
              <div className="why-choose-card">
                <div className="why-choose-img">
                  <img src="/assets/images/photo-1522071820081-009f0129c71c.jpg"
                    alt="Expert Team" />
                </div>
                <div className="why-choose-content">
                  <div className="why-choose-icon">
                    <i className="fa fa-users"></i>
                  </div>
                  <h3>Expert Professionals</h3>
                  <p>Our certified developers, cloud engineers, and security specialists bring years of hands-on experience across every IT discipline, ensuring top-quality results every time.</p>
                  <Link to="/about" className="why-choose-link">Learn more <i className="fa fa-arrow-right"></i></Link>
                </div>
              </div>
            </div>


            <div className="col-lg-6 col-md-6 mb-30" data-aos="flip-right" data-aos-delay="400">
              <div className="why-choose-card">
                <div className="why-choose-img">
                  <img src="/assets/images/photo-1555066931-4365d14bab8c.jpg"
                    alt="Premium Tech Stack" />
                </div>
                <div className="why-choose-content">
                  <div className="why-choose-icon">
                    <i className="fa fa-award"></i>
                  </div>
                  <h3>Premium Tech Stack</h3>
                  <p>We build with modern frameworks, secure cloud infrastructure, and robust databases to deliver scalable software that stands the test of time and performs flawlessly.</p>
                  <a href="#services" className="why-choose-link">Learn more <i className="fa fa-arrow-right"></i></a>
                </div>
              </div>
            </div>


            <div className="col-lg-6 col-md-6 mb-30" data-aos="flip-left" data-aos-delay="600">
              <div className="why-choose-card">
                <div className="why-choose-img">
                  <img src="/assets/images/photo-1551434678-e076c223a692.jpg"
                    alt="Value &amp; Scalability" />
                </div>
                <div className="why-choose-content">
                  <div className="why-choose-icon">
                    <i className="fa fa-hand-holding-usd"></i>
                  </div>
                  <h3>Value &amp; Scalability</h3>
                  <p>We design architectures that grow with your business, optimizing cloud resources to ensure you get the absolute best ROI on your technology investment.</p>
                  <Link to="/contact" className="why-choose-link">Get a Quote <i className="fa fa-arrow-right"></i></Link>
                </div>
              </div>
            </div>


            <div className="col-lg-6 col-md-6 mb-30" data-aos="flip-right" data-aos-delay="800">
              <div className="why-choose-card">
                <div className="why-choose-img">
                  <img src="/assets/images/photo-1563986768609-322da13575f3.jpg"
                    alt="On-Time &amp; Secure" />
                </div>
                <div className="why-choose-content">
                  <div className="why-choose-icon">
                    <i className="fa fa-clock"></i>
                  </div>
                  <h3>On-Time &amp; Secure</h3>
                  <p>We respect your deadlines and prioritize security. Our DevOps automation ensures timely integration, secure builds, and zero-downtime deployment pipelines.</p>
                  <Link to="/gallery" className="why-choose-link">View Projects <i className="fa fa-arrow-right"></i></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      <ExperienceSection />



      <section className="tab-gallery-1 pt-60 pb-60">

        <div className="section-bg-images">
          <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/20-circle-ring.svg')" }} data-aos="flip-down" data-aos-delay="100" data-aos-duration="800"></div>
          <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/47-hexagon-outline.svg')" }} data-aos="rotate-left" data-aos-delay="200" data-aos-duration="1000"></div>
          <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/87-trophy.svg')" }} data-aos="rotate-right" data-aos-delay="300" data-aos-duration="1200"></div>
          <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/44-octagon.svg')" }} data-aos="fade-up" data-aos-delay="400" data-aos-duration="1400"></div>
          <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/94-star-badge.svg')" }} data-aos="fade-down" data-aos-delay="500" data-aos-duration="800"></div>
          <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/75-shield.svg')" }} data-aos="fade-left" data-aos-delay="600" data-aos-duration="1000"></div>
          <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/64-diamond-outline.svg')" }} data-aos="fade-right" data-aos-delay="700" data-aos-duration="1200"></div>
          <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/78-ribbon.svg')" }} data-aos="zoom-in" data-aos-delay="800" data-aos-duration="1400"></div>
          <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/83-rounded-squircle.svg')" }} data-aos="zoom-out" data-aos-delay="900" data-aos-duration="800"></div>
        </div>
        <div className="container">

          <div className="ebl-data-blocks">

            <div className="comingsoon-body-item block-item  text-center" data-aos="fade-down" data-aos-delay="100">
              <div className="subtitle subtitle_1bececf">
                <h4>
                  <span className="subtitle-first-span"></span>
                  <span className="subtitle-middle-span">Our Work</span>
                  <span className="subtitle-last-span"></span>
                </h4>
              </div>
            </div>
            <div className="comingsoon-body-item block-item  text-center" data-aos="fade-down" data-aos-delay="200">
              <div className="title title_1bececf">
                <h2>
                  <span></span>
                  <span>Project Showcase</span>
                  <span></span>
                </h2>
              </div>
            </div>
            <div className="comingsoon-body-item block-item">
              <div className="recent-work">
                <div className="recent-work-wrap">
                  <div className="row justify-content-center mb-5 aos-init aos-animate" data-aos="fade-up">
                    <div id="filters" className="filters text-center button-group col-md-7">
                      <button className="btn active" data-filter="*">All</button>
                      <button className="btn" data-filter=".software">Software</button>
                      <button className="btn" data-filter=".cloud">Cloud &amp; DevOps</button>
                      <button className="btn" data-filter=".vps">VPS &amp; Hosting</button>
                      <button className="btn" data-filter=".design">UI/UX Design</button>
                    </div>
                  </div>
                  <div className="recent-work-grid row" id="portfolio-filter7">
                    <div className="work-grid-wrap item software col-lg-3 col-md-4 col-sm-6" data-aos="flip-left"
                      data-aos-delay="100">
                      <a href="#" className="work-box">
                        <img src="/assets/images/photo-1551288049-bebda4e38f71.jpg"
                          alt="ERP Platform" />
                        <div className="work-box-content hover-content">
                          <h3>CRM/ERP Platform</h3>
                          <span className="work-category">Enterprise Software</span>
                        </div>
                      </a>
                    </div>
                    <div className="work-grid-wrap item cloud col-lg-3 col-md-4 col-sm-6" data-aos="flip-right"
                      data-aos-delay="150">
                      <a href="#" className="work-box">
                        <img src="/assets/images/photo-1451187580459-43490279c0fa.jpg"
                          alt="AWS Cloud Migration" />
                        <div className="work-box-content hover-content">
                          <h3>AWS Cloud Migration</h3>
                          <span className="work-category">Cloud &amp; DevOps</span>
                        </div>
                      </a>
                    </div>
                    <div className="work-grid-wrap item vps col-lg-3 col-md-4 col-sm-6" data-aos="flip-left"
                      data-aos-delay="300">
                      <a href="#" className="work-box">
                        <img src="/assets/images/photo-1558494949-ef010cbdcc31.jpg"
                          alt="E-Commerce VPS Setup" />
                        <div className="work-box-content hover-content">
                          <h3>E-Commerce VPS Setup</h3>
                          <span className="work-category">VPS &amp; Hosting</span>
                        </div>
                      </a>
                    </div>
                    <div className="work-grid-wrap item design col-lg-3 col-md-4 col-sm-6" data-aos="flip-right"
                      data-aos-delay="400">
                      <a href="#" className="work-box">
                        <img src="/assets/images/photo-1512941937669-90a1b58e7e9c.jpg"
                          alt="E-Comm Mobile App" />
                        <div className="work-box-content hover-content">
                          <h3>E-Comm Mobile App</h3>
                          <span className="work-category">UI/UX Design</span>
                        </div>
                      </a>
                    </div>
                    <div className="work-grid-wrap item software col-lg-3 col-md-4 col-sm-6" data-aos="flip-left"
                      data-aos-delay="500">
                      <a href="#" className="work-box">
                        <img src="/assets/images/photo-1460925895917-afdab827c52f.jpg"
                          alt="SaaS Dashboard" />
                        <div className="work-box-content hover-content">
                          <h3>SaaS Dashboard</h3>
                          <span className="work-category">Web Application</span>
                        </div>
                      </a>
                    </div>
                    <div className="work-grid-wrap item design col-lg-3 col-md-4 col-sm-6" data-aos="flip-left"
                      data-aos-delay="600">
                      <a href="#" className="work-box">
                        <img src="/assets/images/photo-1531403009284-440f080d1e12.jpg"
                          alt="Interactive Prototyping" />
                        <div className="work-box-content hover-content">
                          <h3>Interactive Prototyping</h3>
                          <span className="work-category">UI/UX Design</span>
                        </div>
                      </a>
                    </div>
                    <div className="work-grid-wrap item cloud col-lg-3 col-md-4 col-sm-6" data-aos="flip-right"
                      data-aos-delay="200">
                      <a href="#" className="work-box">
                        <img src="/assets/images/photo-1563986768609-322da13575f3.jpg"
                          alt="CI/CD Automation" />
                        <div className="work-box-content hover-content">
                          <h3>CI/CD Automation</h3>
                          <span className="work-category">Cloud &amp; DevOps</span>
                        </div>
                      </a>
                    </div>
                    <div className="work-grid-wrap item vps col-lg-3 col-md-4 col-sm-6" data-aos="flip-left"
                      data-aos-delay="800">
                      <a href="#" className="work-box">
                        <img src="/assets/images/photo-1600132806370-bf17e65e942f.jpg"
                          alt="Server Clustering" />
                        <div className="work-box-content hover-content">
                          <h3>Server Clustering</h3>
                          <span className="work-category">VPS &amp; Hosting</span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonial_section testimonial-1">

        <div className="section-bg-images">
          <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/31-star-5point.svg')" }} data-aos="fade-up" data-aos-delay="100" data-aos-duration="800"></div>
          <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/63-diamond.svg')" }} data-aos="fade-down" data-aos-delay="200" data-aos-duration="1000"></div>
          <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/95-layered-circles.svg')" }} data-aos="fade-left" data-aos-delay="300" data-aos-duration="1200"></div>
          <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/89-gear.svg')" }} data-aos="fade-right" data-aos-delay="400" data-aos-duration="1400"></div>
          <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/96-hexagon-badge.svg')" }} data-aos="zoom-in" data-aos-delay="500" data-aos-duration="800"></div>
          <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/88-bell.svg')" }} data-aos="zoom-out" data-aos-delay="600" data-aos-duration="1000"></div>
          <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/11-circle-basic.svg')" }} data-aos="flip-left" data-aos-delay="700" data-aos-duration="1200"></div>
          <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/40-star-sparkle.svg')" }} data-aos="flip-right" data-aos-delay="800" data-aos-duration="1400"></div>
          <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/50-hexagon-flat.svg')" }} data-aos="flip-up" data-aos-delay="900" data-aos-duration="800"></div>
        </div>
        <div className="container">

          <div className="ebl-data-blocks">
            <div className="comingsoon-body-item block-item text-center" data-aos="fade-down" data-aos-delay="100">
              <div className="subtitle subtitle_1bececf">
                <h4>
                  <span></span>
                  <span>Testimonials</span>
                  <span></span>
                </h4>
              </div>
            </div>
            <div className="comingsoon-body-item block-item text-center" data-aos="fade-down" data-aos-delay="200">
              <div className="title title_1bececf">
                <h2>
                  <span></span>
                  <span>What Our Clients Say About Us</span>
                  <span></span>
                </h2>
              </div>
            </div>
            <div className="comingsoon-body-item block-item text-center" data-aos="fade-down" data-aos-delay="300">
              <div className="plain_text plain_text_1bececf">
                <p>
                  Hear from our satisfied clients across the Middle East & African Regionwho trust Tech Zone FZC
                  for their critical IT architectures. Quality execution, reliable uptime,
                  and robust support.
                </p>
              </div>
            </div>
            <div className="comingsoon-body-item block-item">
              <div className="testimonial testimonial_1bececf">
                <div className="testimonial_wrap testimonial-slider-wrap swiper">
                  <div className="testimonial_slider swiper-wrapper">
                    <div className="swiper-slide">
                      <div className="testimonial_item">
                        <div className="testimonial_top">
                          <div className="testimonial_figure">
                            <div className="testimonial_thumb">
                              <img
                                src="/assets/images/photo-1507003211169-0a1dd7228f2d.jpg"
                                alt="" />
                            </div>
                            <div className="testimonial_icon">
                              <i className="fas fa-quote-left"></i>
                            </div>
                          </div>
                          <div className="designation_area">
                            <div className="designation_title">
                              <h3>Ahmed Hassan</h3>
                            </div>
                            <div className="testimonial_designation">CTO, FinTech StartUp Dubai</div>
                          </div>
                        </div>
                        <div className="testimonial_quotation">
                          <p>
                            "Tech Zone FZC did an outstanding job developing our web platform.
                            The team was professional, agile, and delivered ahead of
                            schedule. Highly recommended for any bespoke enterprise development!"
                          </p>
                          <div className="rating">
                            <ul>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="testimonial_item">
                        <div className="testimonial_top">
                          <div className="testimonial_figure">
                            <div className="testimonial_thumb">
                              <img
                                src="/assets/images/photo-1472099645785-5658abf4ff4e.jpg"
                                alt="" />
                            </div>
                            <div className="testimonial_icon">
                              <i className="fas fa-quote-left"></i>
                            </div>
                          </div>
                          <div className="designation_area">
                            <div className="designation_title">
                              <h3>Mohammad Khan</h3>
                            </div>
                            <div className="testimonial_designation">IT Director, Abu Dhabi Corp</div>
                          </div>
                        </div>
                        <div className="testimonial_quotation">
                          <p>
                            "We hired Tech Zone FZC for our server modernization and
                            database clustering. Their attention to detail, robust security
                            protocols, and cloud expertise exceeded our expectations."
                          </p>
                          <div className="rating">
                            <ul>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="testimonial_item">
                        <div className="testimonial_top">
                          <div className="testimonial_figure">
                            <div className="testimonial_thumb">
                              <img
                                src="/assets/images/photo-1494790108377-be9c29b29330.jpg"
                                alt="" />
                            </div>
                            <div className="testimonial_icon">
                              <i className="fas fa-quote-left"></i>
                            </div>
                          </div>
                          <div className="designation_area">
                            <div className="designation_title">
                              <h3>Sara Al-Mansoori</h3>
                            </div>
                            <div className="testimonial_designation">Product Manager, E-Commerce Sharjah</div>
                          </div>
                        </div>
                        <div className="testimonial_quotation">
                          <p>
                            "The UI/UX design and frontend development by Tech Zone FZC
                            transformed our product completely. Beautiful design, clean
                            interface, and seamless user flows. Excellent service!"
                          </p>
                          <div className="rating">
                            <ul>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="testimonial_item">
                        <div className="testimonial_top">
                          <div className="testimonial_figure">
                            <div className="testimonial_thumb">
                              <img
                                src="/assets/images/photo-1500648767791-00dcc994a43e.jpg"
                                alt="" />
                            </div>
                            <div className="testimonial_icon">
                              <i className="fas fa-quote-left"></i>
                            </div>
                          </div>
                          <div className="designation_area">
                            <div className="designation_title">
                              <h3>Rashid Javed</h3>
                            </div>
                            <div className="testimonial_designation">Managing Director, Dubai Retail</div>
                          </div>
                        </div>
                        <div className="testimonial_quotation">
                          <p>
                            "From cloud migration to VPS hosting setups, Tech Zone FZC
                            handled our complete digital infrastructure. We are very satisfied
                            with their prompt 24/7 technical monitoring and support."
                          </p>
                          <div className="rating">
                            <ul>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                              <li><i className="fa fa-star"></i></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="no-slider swiper-navigation">
                    <div className="swiper-button-prev">
                      <i className="jarrow-arrow-seventy-five-left"></i>
                    </div>
                    <div className="swiper-pagination"></div>
                    <div className="swiper-button-next">
                      <i className="jarrow-arrow-seventy-five-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="newsletter newsletter-1">

        <div className="section-bg-images">
          <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/84-rounded-leaf.svg')" }} data-aos="fade-right" data-aos-delay="100" data-aos-duration="800"></div>
          <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/92-infinity.svg')" }} data-aos="zoom-in" data-aos-delay="200" data-aos-duration="1000"></div>
          <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/75-shield.svg')" }} data-aos="zoom-out" data-aos-delay="300" data-aos-duration="1200"></div>
          <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/42-hexagon.svg')" }} data-aos="flip-left" data-aos-delay="400" data-aos-duration="1400"></div>
          <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/95-layered-circles.svg')" }} data-aos="flip-right" data-aos-delay="500" data-aos-duration="800"></div>
          <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/12-circle-outline.svg')" }} data-aos="flip-up" data-aos-delay="600" data-aos-duration="1000"></div>
          <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/77-badge.svg')" }} data-aos="flip-down" data-aos-delay="700" data-aos-duration="1200"></div>
          <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/99-semicircle.svg')" }} data-aos="rotate-left" data-aos-delay="800" data-aos-duration="1400"></div>
          <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/64-diamond-outline.svg')" }} data-aos="rotate-right" data-aos-delay="900" data-aos-duration="800"></div>
        </div>
        <div className="container">
          <div className="ebl-data-blocks">
            <div className="comingsoon-body-item block-item" data-aos="fade-down" data-aos-delay="100">
              <div className="title title_1bececf">
                <h2>
                  <span></span>
                  <span>Ready to Accelerate Your Digital Growth? Get In Touch!</span>
                  <span></span>
                </h2>
              </div>
            </div>
            <div className="comingsoon-body-item block-item" data-aos="fade-up" data-aos-delay="200">
              <div className="plain_text plain_text_1bececf">
                <p>Call us at <a href="tel:+971502424117" style={{ color: "#D4AF37", fontWeight: "bold" }}>+971 50 24 24 117</a>
                  or
                  fill out the form below for a free IT consultation</p>
              </div>
            </div>
            <div className="comingsoon-body-item block-item" data-aos="zoom-in" data-aos-delay="300">
              <div className="subscribe subscribe_1bececf">
                <div className="subscribe_wrap">
                  <form onSubmit={(e) => {
                    e.preventDefault();
                    const email = e.target.subscribe_input.value;
                    if (typeof window !== "undefined" && window.$) {
                      window.$("#quoteModal").addClass("active");
                      window.$("body").css("overflow", "hidden");
                      
                      // Pre-fill the email field if present
                      const emailInput = document.getElementById('quoteEmail');
                      if (emailInput && email) {
                        emailInput.value = email;
                      }
                    }
                  }}>
                    <div className="subscribe_form">
                      <div className="subscribe_form_group">
                        <input type="email" name="subscribe_input" id="subscribe_input"
                          placeholder="Enter Your Email Address" required />
                        <button className="subcribe-btn" type="submit">Get Quote</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>

        </div>
      </section>
      <section className="faq-block-2 pt-60 pb-60" style={{ backgroundColor: "#f8f9fb" }}>

        <div className="section-bg-images">
          <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/89-gear.svg')" }} data-aos="flip-left" data-aos-delay="100" data-aos-duration="800"></div>
          <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/87-trophy.svg')" }} data-aos="flip-right" data-aos-delay="200" data-aos-duration="1000"></div>
          <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/20-circle-ring.svg')" }} data-aos="flip-up" data-aos-delay="300" data-aos-duration="1200"></div>
          <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/83-rounded-squircle.svg')" }} data-aos="flip-down" data-aos-delay="400" data-aos-duration="1400"></div>
          <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/94-star-badge.svg')" }} data-aos="rotate-left" data-aos-delay="500" data-aos-duration="800"></div>
          <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/44-octagon.svg')" }} data-aos="rotate-right" data-aos-delay="600" data-aos-duration="1000"></div>
          <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/48-octagon-outline.svg')" }} data-aos="fade-up" data-aos-delay="700" data-aos-duration="1200"></div>
          <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/85-wave.svg')" }} data-aos="fade-down" data-aos-delay="800" data-aos-duration="1400"></div>
          <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/47-hexagon-outline.svg')" }} data-aos="fade-left" data-aos-delay="900" data-aos-duration="800"></div>
        </div>
        <div className="container" data-aos="fade-up">
          <div className="text-center mb-5">
            <div className="subtitle subtitle_1bececf">
              <h4>
                <span className="subtitle-first-span"></span>
                <span className="subtitle-middle-span">Frequently Asked Questions</span>
                <span className="subtitle-last-span"></span>
              </h4>
            </div>
            <div className="title title_1bececf">
              <h2><span></span><span>IT Services &amp; Products FAQ</span><span></span></h2>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-10">
              <ul className="accordion-list">
                <li className="active">
                  <h3>
                    <span>What IT services does Tech Zone FZC specialize in?</span>
                    <span><i className="jarrow-arrow-seventy-four-down"></i></span>
                  </h3>
                  <div className="answer" style={{ display: "block" }}>
                    <p>
                      We specialize in custom web and mobile application development, enterprise CRM/ERP integrations, cloud infrastructure (AWS/Azure/GCP), managed VPS hosting, proactive server management, AI &amp; data solutions, and comprehensive cybersecurity audits.
                    </p>
                  </div>
                </li>
                <li>
                  <h3>
                    <span>Are your IT products ready to deploy or custom-built?</span>
                    <span><i className="jarrow-arrow-seventy-four-down"></i></span>
                  </h3>
                  <div className="answer">
                    <p>
                      We offer both! We provide ready-to-deploy premium product licenses (like our CRM &amp; ERP suites and pre-configured VPS server clusters) which can be set up immediately, as well as bespoke software engineering tailored to your exact business workflows.
                    </p>
                  </div>
                </li>
                <li>
                  <h3>
                    <span>Do you provide post-deployment support and server maintenance?</span>
                    <span><i className="jarrow-arrow-seventy-four-down"></i></span>
                  </h3>
                  <div className="answer">
                    <p>
                      Yes, we provide 24/7 proactive monitoring, security patches, database backups, and server optimization as part of our managed maintenance agreements, ensuring your systems remain secure and scale smoothly.
                    </p>
                  </div>
                </li>
                <li>
                  <h3>
                    <span>How do we get started with a project?</span>
                    <span><i className="jarrow-arrow-seventy-four-down"></i></span>
                  </h3>
                  <div className="answer">
                    <p>
                      Simply click on the "Get A Quote" button, fill in your requirements, and our technical leads will arrange a free IT consultation to map out your architecture and deliver a detailed commercial proposal.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

    </>
  );
}
